module.exports = __webpack_public_path__ + "img/pen-to-square.6ca82a07.svg";